import {
  ContentDifficulty,
  ContentDifficultyMix,
} from "../../../common/contentTypes";

export const DEFAULT_DIFFICULTY_MIX: ContentDifficultyMix = {
  easy: 50,
  medium: 35,
  hard: 15,
};

export const DIFFICULTY_ORDER: ContentDifficulty[] = ["easy", "medium", "hard"];

export const mixTotal = (mix: ContentDifficultyMix): number =>
  mix.easy + mix.medium + mix.hard;

/**
 * Moves one share and absorbs the difference in the other two, so the mix always
 * sums to exactly 100 — which is what the platform validator requires. Three
 * independent sliders would let an admin build an invalid mix and only discover
 * it on submit.
 *
 * The remainder is split in proportion to the other two's current values so
 * their relative balance survives, and any rounding drift lands on whichever of
 * them is larger. When both are zero there is nothing to be proportional to, so
 * it splits evenly.
 */
export const rebalanceMix = (
  mix: ContentDifficultyMix,
  changed: ContentDifficulty,
  value: number,
): ContentDifficultyMix => {
  const next = Math.max(0, Math.min(100, Math.round(value)));
  const others = DIFFICULTY_ORDER.filter((key) => key !== changed);
  const remaining = 100 - next;
  const othersTotal = mix[others[0]] + mix[others[1]];

  const first =
    othersTotal > 0
      ? Math.round((mix[others[0]] / othersTotal) * remaining)
      : Math.round(remaining / 2);

  const result = {
    ...mix,
    [changed]: next,
    [others[0]]: first,
    [others[1]]: remaining - first,
  } as ContentDifficultyMix;

  return result;
};
